import { useState } from "react";
import { Card, CardContent } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { ErroConsulta } from "@/components/ErroConsulta";
import { TabelaDeSolicitacoes } from "@/components/lgpd/TabelaDeSolicitacoes";

const FILTROS = [
  ["PENDENTE", "Pendentes"],
  ["", "Todas"],
] as const;

/** Pedidos LGPD dos titulares — reset e exclusão só acontecem daqui, com o pedido deles. */
export function AdminSolicitacoesLgpd() {
  const [status, setStatus] = useState<"PENDENTE" | "">("PENDENTE");
  const { data, isLoading, error } = trpc.admin.lgpd.list.useQuery({ status: status || undefined });
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-admin-900">Solicitações LGPD</h1>
        <p className="mt-1 text-sm text-admin-700">
          Reset e exclusão pedidos pelo titular em Minha conta › Privacidade e dados. Executar exige o e-mail da conta.
        </p>
      </div>
      <div className="flex gap-1">
        {FILTROS.map(([valor, rotulo]) => (
          <button
            key={rotulo}
            type="button"
            onClick={() => setStatus(valor)}
            className={`h-8 rounded-md px-3 text-xs font-semibold ${status === valor ? "bg-admin-900 text-white" : "text-admin-700 hover:bg-zinc-100"}`}
          >
            {rotulo}
          </button>
        ))}
      </div>
      <Card className="border-admin-200">
        <CardContent className="overflow-x-auto p-0">
          {error ? (
            <div className="p-5"><ErroConsulta error={error} /></div>
          ) : isLoading ? (
            <div className="flex justify-center py-16"><div className="h-8 w-8 animate-spin rounded-full border-2 border-admin-900 border-t-transparent" /></div>
          ) : (
            <TabelaDeSolicitacoes itens={data ?? []} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
